module.exports = __webpack_public_path__ + "img/star.3eca2164.svg";